module.exports = __webpack_public_path__ + "static/feathr-4.a02f3549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/feathr/feathr-4.jpg
// module id = 488
// module chunks = 33212578467737